import { useQuery } from "@tanstack/react-query"
import { getEmployeeKpiBreakdown } from "api/employeeKpiApi"

export const useEmployeeKpiBreakdown = (employeeId, month, year, enabled = true) => {
  return useQuery({
    queryKey: ["employee-kpi-breakdown", employeeId, month, year],
    queryFn: () => getEmployeeKpiBreakdown(employeeId, { month, year }),
    staleTime: 1000 * 60 * 5,
    enabled: enabled && !!employeeId,
  })
}
